import React from 'react';

export function StatusColumnFormatter(cellContent) {
  const {statusName, statusID} = cellContent;
  const isFrozen = statusID === 2;
  const style = {
    background: isFrozen ? '#F2E6E6' : '#CDEADB',
    border: `1px solid ${isFrozen ? 'rgb(239, 65, 48)' : 'rgb(65, 141, 88)'}`,
    color: isFrozen ? 'rgb(239, 65, 48)' : 'rgb(65, 141, 88)',
  };

  return (
    <div className="badge badge-pill w-100px font-size-h4 text-nowrap" style={style}>
      {statusName}
    </div>
  );
}